module.exports = __webpack_public_path__ + "img/image-active.017560a4.png";